import Zliving1 from '../../Media/Produk/Zliving.webp'
import Zliving2 from '../../Media/Produk/Zliving.webp'



const Zlivingimages =[
    Zliving1,Zliving2
]

export default Zlivingimages;